import { useAsyncData } from "./useAsyncData";
import { businessProfileService } from "../services/businessProfileService";

export function useBusinessProfile(tenantId?: string | null) {
  return useAsyncData(
    () =>
      tenantId
        ? businessProfileService.getForTenant(tenantId)
        : Promise.reject(new Error("No workspace selected.")),
    [tenantId],
  );
}
